import isValidRecipient from '../utils/isValidRecipient';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import { FeedbackManagerState } from 'owa-feedback-manager/lib/store/schema/FeedbackManagerState';
import {
    FindResultType,
    DirectorySearchType,
} from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import { RecipientExpansionStatus } from 'owa-recipient-common/lib/store/schema/RecipientExpansionStatus';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

let globalRecipientWellId = 0;

export default function createRecipientWell(
    findPeopleFeedbackManager?: FeedbackManagerState,
    initialEmails?: EmailAddressWrapper[]
): RecipientWellWithFindControlViewState {
    let recipientWell: RecipientWellWithFindControlViewState = {
        recipientWellId: `rw-${++globalRecipientWellId}`,
        queryString: '',
        recipients: [],
        isDirty: false,
        shouldShowFindResult: false,
        shouldShowContactPicker: false,
        findResultSet: [],
        findResultType: FindResultType.None,
        findResultHightlightIndex: -1,
        isSearching: false,
        directorySearchType: DirectorySearchType.None,
        dropViewState: createDropViewState(),
        findPeopleFeedbackManager: findPeopleFeedbackManager,
    };

    if (initialEmails) {
        for (let email of initialEmails) {
            let recipient: ReadWriteRecipientViewState = {
                displayText: email.Name,
                persona: { EmailAddress: email, PersonaId: email.ItemId },
                isContextMenuOpen: false,
                isValid: isValidRecipient(email),
                isSelected: false,
                isExpanding: false,
                isEditing: false,
                isFadedOut: false,
                expansionStatus: RecipientExpansionStatus.None,
                members: [],
            };

            recipientWell.recipients.push(recipient);
        }
    }

    return recipientWell;
}
